import { TOGGLE_INSTALL_COCOPARKS } from "./displayInstallCocoparksReducer"

export const toggleInstallCocoparks = (value) => ({
    type: TOGGLE_INSTALL_COCOPARKS,
    payload: value
})